module.exports = new __parcel__URL__("svg-error-window.ffce7d1e.svg").toString();